module.exports = __webpack_public_path__ + "static/media/logo-ezgo.2dacffe8.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Logos/logo-ezgo.png
// module id = 1263
// module chunks = 0